var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { LinearProgress } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNotify } from '../../hooks/notificationHook';
import { useRequest } from '../../hooks/requestHook';
import { invoice as api } from '../../api';
import * as Sentry from '@sentry/react';
var StripePaymentResult = function (_a) {
    var invoiceId = _a.invoiceId;
    var t = useTranslation().t;
    var stripe = useStripe();
    var notify = useNotify();
    var navigate = useNavigate();
    var paymentIntentStatusCheckApi = useRequest(api.stripePaymentIntentStatusCheck);
    var search = useLocation().search;
    var _b = React.useState(), loading = _b[0], setLoading = _b[1];
    var handlePaymentIntentStatusCheck = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, paymentIntentStatusCheckApi(invoiceId)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response) {
                        Sentry.captureMessage("\u8ACB\u6C42\u66F8: ".concat(invoiceId, "\u306Estripe\u6C7A\u6E08\u5F8C\u306E\u51E6\u7406\u304C\u5931\u6557\u3057\u307E\u3057\u305F"));
                        throw Error('error response');
                    }
                    notify('success', [t('messages.updateSuccessInvoicePaid')]);
                    return [2 /*return*/];
            }
        });
    }); }, [invoiceId, paymentIntentStatusCheckApi, notify, t]);
    React.useEffect(function () {
        if (!stripe) {
            return;
        }
        var query = new URLSearchParams(search);
        var clientSecret = query.get('payment_intent_client_secret') || '';
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var paymentIntent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, stripe.retrievePaymentIntent(clientSecret)];
                    case 1:
                        paymentIntent = (_a.sent()).paymentIntent;
                        setLoading(false);
                        if (!paymentIntent)
                            return [2 /*return*/];
                        if (!(paymentIntent.status === 'succeeded')) return [3 /*break*/, 3];
                        return [4 /*yield*/, handlePaymentIntentStatusCheck()];
                    case 2:
                        _a.sent();
                        navigate("/roaster/invoices/".concat(invoiceId));
                        return [3 /*break*/, 4];
                    case 3:
                        if (paymentIntent.status === 'processing') {
                            Sentry.captureMessage("\u8ACB\u6C42\u66F8: ".concat(invoiceId, "\u306Estripe\u306E\u6C7A\u6E08\u30B9\u30C6\u30FC\u30BF\u30B9\u304Cprocessing\u306B\u306A\u308A\u307E\u3057\u305F"));
                        }
                        else {
                            notify('error', [t('stripePayment.failure')]);
                            Sentry.captureMessage("\u8ACB\u6C42\u66F8: ".concat(invoiceId, "\u306Estripe\u306E\u6C7A\u6E08\u304C\u5931\u6557\u3057\u307E\u3057\u305F"));
                            navigate("/roaster/invoices/".concat(invoiceId, "/payment"));
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [
        stripe,
        search,
        notify,
        t,
        navigate,
        invoiceId,
        handlePaymentIntentStatusCheck,
    ]);
    if (loading)
        return React.createElement(LinearProgress, null);
    return null;
};
export default StripePaymentResult;
